import { createFileRoute } from "@tanstack/react-router"

import { GoodsReceiptCommentsTab } from "@/screens/WarehouseReceiving/components"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout/comments")({
  component: GoodsReceiptCommentsTab,
})
